/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsdoc/require-example */
/* eslint-disable react/no-danger */

// 针对SSR实现的详情页渲染逻辑，这里去掉了CSR的转码逻辑，需要单独引入
// 纯SSR的转码和渲染逻辑与CSR有较大的差异，注意以后调整的时候不要对着抄

import React from 'react';
import HtmlToReact from 'html-to-react';
import { createRoot } from 'react-dom/client';
import WebImage from '../component/web-image';
import { MenuType } from '../types/global';
import { getOffset } from '../tools/ui';
import { LogEventType } from '../component/hashtag-item';
import { processDetail, processTitleTag } from '../tools/process';
import {
  genPoiProcessingInstruction,
  genArchorProcessingInstruction,
  genInsProcessingInstruction,
  genGoodsProcessingInstruction,
  genMenuProcessingInstruction,
  genHashtagProcessingInstruction,
  genPoiArchorProcessingInstruction,
  genMentionedAnchorInstruction,
  genSearchAnchorInstruction
} from '../tools/process/process-instructions';

const HtmlToReactParser = HtmlToReact.Parser;

const htmlToReactParser = new HtmlToReactParser();
const isValidNode = function() {
  return true;
};
const ONLINE_DOMAIN = 'https://www.lemon8-app.com';
const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);

export type ArticlePropType = {
  ref?: (c: any) => void;
  articleTitle?: string;
  children: string;
  groupId: string;
  isShow: boolean;
  isSSR: boolean;
  countryRegion: string;
  onMenuUpdate: (menulist: MenuType[]) => void;
  onLinkClick?: (data: any, type: string) => void;
  onImpression?: (data: any, type: string) => void;
  onLogEvent?: (eventName: string, eventParams: any) => void;
  onHashtagClick?: (pathName: string) => void;
  onPoiClick?: (pathName: string) => void;
  onMentionedClick?: (pathName: string, mentionedId: string) => void;
  onSearchWordAnchorClick?: (word: string) => void;
  onImageClick?: (
    images: string[],
    index: number,
    altPropValue: string,
    type?: 'single' | 'double',
  ) => void;
} & Partial<DefaultProps>;

type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
  groupId: '',
  isiOS: false,
  isInApp: false,
  isShow: false,
  isSSR: false,
  onMenuUpdate: (menulist: MenuType[]) => {
    // empty
  },
  onLinkClick: (data: any, type: string) => {
    // empty
  },
  onImpression: (data: any, type: string) => {
    // empty
  },
  onHashtagClick: (pathName: string) => {
    // empty
  },
  onPoiClick: (pathName: string) => {
    // empty
  },
  onMentionedClick: (pathName: string, mentionedId: string) => {
    // empty
  },
  onLogEvent: (eventName: string, eventParams: any) => {
    // empty
  },
  onSearchWordAnchorClick:(word: string) => {
    // empty
  },

  onImageClick: (
    images: string[],
    index: number,
    altPropValue: string,
    type?: 'single' | 'double',
  ) => {
    // empty
  },
};

export type ArticleStateType = {
  htmlString: string; // 因为数据是SSR的，所以这里要求拿到的数据已经是经过了常规转码的
  groupId: string;
  html: string;
  showBtn?: boolean;
};

export class Article<T> extends React.Component<
  ArticlePropType & T,
  ArticleStateType
> {
  static defaultProps: DefaultProps = defaultProps;

  static getDerivedStateFromProps(props, state) {
    if (
      props.groupId !== state.groupId ||
      props.children !== state.htmlString
    ) {
      return {
        htmlString: `${props.children}`,
        groupId: props.groupId,
        html: processDetail(`${props.children}`, props.countryRegion),
      };
    }
    return null;
  }

  state: ArticleStateType = {
    htmlString: `${this.props.children}`,
    groupId: this.props.groupId,
    html: processDetail(`${this.props.children}`, this.props.countryRegion),
  };

  el: any = null;

  private images: any[] = [];

  private readonly menuList: MenuType[] = [];

  private readonly treeMenu: MenuType[] = [];

  constructor(props: ArticlePropType) {
    super(props);
    console.time('first');
    const { html } = this.state;
    const { isShow } = this.props;
    this.menuList = processTitleTag(html, isShow);
    this.treeMenu = this.toTree(this.menuList);
  }

  componentDidMount() {
    const { groupId, isSSR } = this.props;
    // 如果渲染时就有文章数据，那么直接水合
    if (groupId) {
      if (!isSSR) {
        this.images = [];
        // this.updateMenuList();
        this.hydrate(false);
      }
      this.updateMenuList();
    }
  }

  getSnapshotBeforeUpdate(prevProps) {
    const { groupId, children } = this.props;
    // 这里根据状态变换判断是否需要hydrate，groupId发生变化意味内容都会变化，需要水合
    return {
      needUpdate:
        prevProps.groupId !== groupId ||
        `${children}` !== `${prevProps.children}`,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // If we have a snapshot value, we've just added new items.
    // Adjust scroll so these new items don't push the old ones out of view.
    // (snapshot here is the value returned from getSnapshotBeforeUpdate)
    if (snapshot.needUpdate && this.el) {
      // this.updateMenuList();
      this.images = [];
      this.hydrate(false);
      this.updateMenuList();
    }
  }

  computeMenuTopMap: () => any = () => {
    const map = {};
    ['h1', 'h2', 'h3'].forEach(headerName => {
      const headers = document.querySelectorAll(headerName);
      headers.forEach(header => {
        if (header.children[0]) {
          map[header.children[0].id] = getOffset(header).top;
        }
      });
    });
    return map;
  };

  // 形成树状
  toTree: (data: MenuType[]) => any = data => {
    const map = {};
    data.forEach(function(item) {
      map[item.id] = item;
      item.children = undefined;
    });
    const maxLength = data.length;
    const val: any[] = [];
    const formatTree: (
      item: MenuType,
      parentId: string,
      nextindex: number,
    ) => void = (item, parentId, nextindex) => {
      if (nextindex >= maxLength) {
        return;
      }
      if (data[nextindex].type > item.type) {
        data[nextindex].pid = item.id;
        data[nextindex].level = item.level + 1;
        if (
          !item.maxChildren ||
          (item.maxChildren && item.maxChildren > data[nextindex].type)
        ) {
          item.maxChildren = data[nextindex].type;
          if (item.children) {
            item.children = item.children.map(child => {
              if (item.maxChildren && child.type > item.maxChildren) {
                child.level += 1;
              }
              return child;
            });
          }
        }
        (item.children || (item.children = [])).push(data[nextindex]);

        formatTree(data[nextindex], item.id, nextindex + 1);
      } else if (parentId !== 'h0') {
        formatTree(map[parentId], map[parentId].pid, nextindex);
      } else {
        val.push(data[nextindex]);
        formatTree(data[nextindex], 'h0', nextindex + 1);
      }
    };
    val.push(data[0]);
    formatTree(data[0], 'h0', 1);
    return val;
  };

  updateMenuList: () => void = () => {
    // 通知外部当前文章的目录结构
    const { isShow } = this.props;
    const menuTopMap = this.computeMenuTopMap();
    this.menuList.forEach(menu => {
      menu.top = menuTopMap[menu.id];
    });
    // parseTreeJson(this.treeMenu);
    if (isShow) {
      this.props.onMenuUpdate(this.treeMenu);
    }
    this.props.onMenuUpdate(this.menuList);
  };

  /**
   * 当卡片 出现到视窗 时的处理
   *
   * @param data - 内层卡片传出来的数据（目前来看是用于 trackEvent)
   * @param cardType - 卡片类型
   */
  handleImpression: (data: any, cardType: string) => void = (
    data,
    cardType,
  ) => {
    const { onImpression } = this.props;
    if (onImpression) {
      onImpression(data, cardType);
    }
  };

  /**
   * 处理文章组件需要埋点情况
   *
   * @param data - 埋点相关信息
   */
 handleLogEvent: (data: LogEventType) => void = (
    data,
  ) => {
    const { onLogEvent } = this.props;
    const { eventName = '', eventParams = {} } = data;
    if (onLogEvent) {
      onLogEvent(eventName, eventParams);
    }
  };

  /**
   * 处理正文hashtag SPA跳转
   *
   * @param href hashtag 链接
   */
  handleHashtagClick: (topicHref: string, topicId: string) => void = (topicHref, topicId) => {
    const { onHashtagClick, countryRegion } = this.props;
    const pathName = `/topic/${topicId}`;
    if (onHashtagClick) {
      // 外面传来的SPA跳转方法
      onHashtagClick(pathName);
    } else {
      // 没传SPA跳转，走MPA
      window.open(`${ONLINE_DOMAIN}${topicHref}?region=${countryRegion}`);
    }
  }

  /**
   * 处理正文poi SPA跳转
   * @param poiHref
   * @param poiId
   */
  handlePoiClick: (poiHref: string, poiId: string) => void = (poiHref, poiId) => {
    const { onPoiClick, countryRegion } = this.props;
    const pathName = `/poi/${poiId}`;
    if (onPoiClick) {
      // 外面传来的SPA跳转方法
      onPoiClick(pathName);
    } else {
      // 没传SPA跳转，走MPA
      window.open(`${ONLINE_DOMAIN}${poiHref}?region=${countryRegion}`);
    }
  }

  /**
   * 处理正文mentioned user跳转
   * mentionedHref为user_unique_name
   * @param mentionedHref
   */
  handleMentionedClick: (mentionedHref: string, mentionedId: string) => void = (mentionedHref, mentionedId) => {
    const { onMentionedClick, countryRegion } = this.props;
    if (onMentionedClick) {
      // 外面传来的SPA跳转方法
      onMentionedClick(mentionedHref, mentionedId);
    } else {
      // 没传SPA跳转，走MPA
      window.open(`${ONLINE_DOMAIN}${mentionedHref}?region=${countryRegion}`);
    }
  }

  /**
   * 点击 卡片 时的处理
   *
   * @param data - 内层卡片传出来的数据
   * @param cardType - 卡片类型
   */
  handleLinkClick: (data: any, cardType: string) => void = (data, cardType) => {
    const { isInApp, onLinkClick } = this.props;
    // 端内的逻辑放到更上层的组件里，不在这一层处理，因为依赖版本号

    // if (!isInApp) {
    //   if (cardType !== 'menuitem') {
    //     window.open(data.href);
    //   }
    // }
    if (onLinkClick) {
      let params = data;
      if (cardType === 'menuitem') {
        params = { menuList: this.menuList, id: data };
      }
      onLinkClick(params, cardType);
    }
  };

  handleImageClick: (
    src: string,
    index: number,
    altPropValue: string,
  ) => void = (src, index, altProp) => {
    // 这里触发外部的图片浏览策略
    const { onImageClick } = this.props;
    if (onImageClick) {
      onImageClick(this.images, index, altProp);
    }
  };

  handleSearchWordAnchorClick: (word: string) => void = word => {
    const { onSearchWordAnchorClick } = this.props;
    if (onSearchWordAnchorClick) {
      onSearchWordAnchorClick(word);
    }
  }

  renderImage: (imgConfig: any) => any = imgConfig => {
    const { child, _index, altPropValue } = imgConfig;
    this.images.push(child.props.origin_src);
    const { groupId } = this.state;
    return (
      <WebImage
        altProp={altPropValue}
        key={`${groupId}-image-${_index}`}
        {...child.props}
        style={child.style}
        groupId={groupId}
        index={_index}
        onClick={this.handleImageClick}
      />
    );
  };

  hydrate: (isSSR: boolean, isNative?: boolean) => any = (
    isSSR,
    isNative = false,
  ) => {
    const { html } = this.state;
    const { articleTitle = '', isShow = false, countryRegion } = this.props;
    // 用于计算图片标签的index
    let imageIndex = 0;
    console.timeEnd('first');
    console.time('second');
    // const originImageList: any[] = [];
    // 当前最高的标题类目
    // const menuTopLevel = 'h3';
    // const menuList: MenuType[] = [];
    // const menuTopMap: any = isSSR && !isNative ? [] : this.computeMenuTopMap();
    // 图片点击监听的事件，因为取不到this，所以这里做桥接

    const imageProcessingInstruction = {
      replaceChildren: true,
      shouldProcessNode(node: any) {
        // 替换full接口下发的模板字段中的图片标签
        return node.attribs && node.attribs.class === 'image-container';
      },
      processNode: (node: any, children: any) => {
        const caption = node.attribs['data-caption'];
        const altPropValue = caption
          ? `${articleTitle}|${caption}の画像`
          : `${articleTitle}の画像`;
        const _index = imageIndex;
        imageIndex++;
        // 这里看上去是个map，其实只会有一个img节点
        return children.map((child: any) => {
          if (child && child.props && child.props.className === 'image') {
            const config = { child, _index, altPropValue };
            const imgComponent = this.renderImage(config);
            return imgComponent;
          }
          return null;
        });
      },
    };

    // 图片处理完后存一下
    // this.images = originImageList;
    // 处理转码逻辑
    const processingInstructions = [
      imageProcessingInstruction,
      genArchorProcessingInstruction((data: any) =>
        this.handleLinkClick(data, 'link'),
      ),
      genSearchAnchorInstruction(
        (word: string) => this.handleSearchWordAnchorClick(word),
        (data: LogEventType) => this.handleLogEvent(data),
        countryRegion
      ),
      genHashtagProcessingInstruction(
        (topicHref: string, topicId: string) => this.handleHashtagClick(topicHref, topicId),
        (data: LogEventType) => this.handleLogEvent(data),
        countryRegion
      ),
      genMentionedAnchorInstruction(
        (mentionedHref: string, mentionedId: string) => this.handleMentionedClick(mentionedHref, mentionedId),
        (data: LogEventType) => this.handleLogEvent(data),
      ),
      genPoiArchorProcessingInstruction(
        (poiHref: string, poiId: string) => this.handlePoiClick(poiHref, poiId),
        (data: LogEventType) => this.handleLogEvent(data),
        countryRegion
      ),
      genPoiProcessingInstruction((data: any) =>
        this.handleLinkClick(data, 'poi'),
      ),
      genInsProcessingInstruction((data: any) =>
        this.handleLinkClick(data, 'ins'),
      ),
      genGoodsProcessingInstruction(
        (data: any) => this.handleLinkClick(data, 'goods'),
        (data: any) => this.handleImpression(data, 'goods'),
      ),
      genMenuProcessingInstruction(
        isShow,
        this.treeMenu,
        (data: any) => this.handleLinkClick(data, 'menuitem'),
        () => this.updateMenuList(),
      ),
      {
        // Anything else
        shouldProcessNode() {
          return true;
        },
        processNode: (node: any, children: any[]) => {
          return processNodeDefinitions.processDefaultNode(node, children);
        },
      },
    ];
    // 生成React.Component
    const reactComponent = htmlToReactParser.parseWithInstructions(
      html,
      isValidNode,
      processingInstructions,
    );
    // for inner fiber node tree and SyntheticEvent
    const articleComponent = (
      <div className="inner-content" onClick={this.handleArticleClick}>
        {reactComponent}
      </div>
    );
    if (isSSR) {
      return articleComponent;
    }
    const root = createRoot(this.el);
    root.render(articleComponent);
  };

  handleArticleClick: (e: any) => void = e => {};

  render() {
    const { groupId, html } = this.state;
    const { isSSR } = this.props;
    if (isSSR) {
      return (
        <div key={groupId} id="content" ref={e => (this.el = e)}>
          {this.hydrate(true)}
        </div>
      );
    } else {
      return (
        <div
          key={groupId}
          id="content"
          ref={e => (this.el = e)}
          dangerouslySetInnerHTML={{
            __html: `<div class='inner-content'>${html}</div>`,
          }}></div>
      );
    }
  }
}
